<script setup lang="ts">
// types
import type { BlockInternalLinkProps } from '@ts-blocks/block-internal-link/interfaces'
// hooks
import { useBlockInternalLink } from '@hooks/blocks/block-internal-link.hook'

defineOptions({
  name: 'BlockInternalLink',
})

defineProps<{
  block: BlockInternalLinkProps
}>()

const {
  buildChipHref,
  handleChipClick,
} = useBlockInternalLink()
</script>

<template>
  <nav
    class="block-internal-link"
    :aria-label="block.title"
  >
    <h2 class="block-internal-link__title btly-text-heading-m md:btly-text-heading-l">
      {{ block.title }}
    </h2>
    <ul class="block-internal-link__cloud">
      <li
        v-for="(item, index) in block.links"
        :key="item.id ?? index"
        class="block-internal-link__item"
      >
        <a
          class="block-internal-link__chip btly-text-title-m"
          :href="buildChipHref(item)"
          @click="handleChipClick(item)"
        >{{ item.text }}</a>
      </li>
    </ul>
  </nav>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockInternalLink.scss" />
